import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.emisores.suggestions = {
      ...state.app.emisores.suggestions,
      filters: {
        ...state.app.emisores.suggestions.filters,
        ...meta,
      },
      pagination: {
        ...state.app.emisores.suggestions.pagination,
        limit: meta.limit ?? 25,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.emisores.suggestions;

    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      include: 'nomina,series',
    };

    const response = await Http.get('api/emisores', { params });

    store.setState((state) => {
      state.app.emisores.suggestions = {
        ...state.app.emisores.suggestions,
        data: response.data,
        pagination: {
          ...state.app.emisores.suggestions.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
        busy: false,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.emisores.suggestions.busy = false;
      state.app.emisores.suggestions.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.emisores.suggestions = { ...initialState };
  });
};

const EmisorSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default EmisorSuggestionsStore;
